import { type ContextSourceField, type ContextSourceFieldValueFile } from '~/components/v2/types/contextSources';

export function isContextSourceFieldFile(
  field: ContextSourceField,
): field is ContextSourceField & { valueType: 'file'; values: ContextSourceFieldValueFile[] } {
  return field.valueType === 'file';
}
